import { Badge, BadgeProps, Button, IconButton } from '@mui/material';
import { Iconify } from 'src/components/iconify';

import { styled } from '@mui/system';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import { useLocales } from 'src/locales';
import { PinnedMessagesPopover } from 'src/sections/@dashboard/chat/ChatHeader/PinnedMessages/PinnedMessagesPopover';
import { usePinnedMessages } from './usePinnedMessages';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    minWidth: theme.spacing(2),
    height: theme.spacing(2),
    padding: theme.spacing(0, 0.5),
    top: theme.spacing(0.5),
    right: theme.spacing(0.25),
  },
}));

type Props = {
  channelId: string;
  compact?: boolean;
};

export const PinnedMessage = ({ channelId, compact }: Props) => {
  const { messagesData } = usePinnedMessages({ channelId });
  const { translate } = useLocales();
  return (
    <StyledBadge badgeContent={messagesData?.length} color="primary">
      <PopoverTrigger popover={PinnedMessagesPopover} context={{ channelId }}>
        {compact ? (
          <IconButton>
            <Iconify sx={{ transform: 'rotate(315deg)' }} icon="tabler:pin" />
          </IconButton>
        ) : (
          <Button
            sx={{ fontWeight: 'fontWeightRegular' }}
            startIcon={
              <Iconify sx={{ transform: 'rotate(315deg)' }} icon="tabler:pin" />
            }
          >
            {translate('shared.buttons.pinned')}
          </Button>
        )}
      </PopoverTrigger>
    </StyledBadge>
  );
};
